<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let label = "";
</script>

<style>
	.tag {
		padding: 2px 10px;
		margin: 5px;
		background-color: lightgray;
		border-radius: 6px;
		display: inline-block;
	}
</style>

<div class="tag">
{label} | <span on:click={e => dispatch("removeTag")} class="clickable">x</span>
</div>
